module.exports = require("@swa-ui/core/src/Shimmer/Shimmer.module.scss");